import { apiGet } from "../../helpers/ApiHelper";
import { getChainsApiHost } from "../../helpers/config";

export const SUPPORTED_CHAINS_LOADING = 'SUPPORTED_CHAINS_LOADING';
export const SUPPORTED_CHAINS_LOADED = 'SUPPORTED_CHAINS_LOADED';
export const SUPPORTED_CHAINS_ERROR = 'SUPPORTED_CHAINS_ERROR';

export const getSupportedChains = () => {
    let url = getChainsApiHost() + '/api/v1/supported_chains';
    return apiGet(url, { },
        [SUPPORTED_CHAINS_LOADING, SUPPORTED_CHAINS_LOADED, SUPPORTED_CHAINS_ERROR]);
};

const ACTION_HANDLERS = {
    [SUPPORTED_CHAINS_LOADING] : (state, action)=>{
        return {
            ...state,
            chainsLoading : true,
            chainsLoaded : false,
            chainsError: false,
            chainsErrorMsg : ''
        }
    },
    [SUPPORTED_CHAINS_LOADED] : (state, action)=>{
        return {
            ...state,
            chainsLoading : false,
            chainsLoaded : true,
            chainsError : false,
            chainsData : action.payload.result,
            chainsErrorMsg : ''
        }
    },
    [SUPPORTED_CHAINS_ERROR] : (state, action)=>{
        return {
            ...state,
            chainsLoading : false,
            chainsLoaded : false,
            chainsError : true,
            chainsData : undefined,
            chainsErrorMsg : action.payload.msg
        }
    },
};

const initialState = {
    
    chainsLoading : false,
    chainsLoaded : false,
    chainsError : false,
    chainsData : undefined,
    chainsErrorMsg : '',

};

export default function noticeReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};